import { Injectable } from '@angular/core';
import jsSHA from 'jssha';
import { FormGroup, ValidatorFn, ValidationErrors } from '@angular/forms';
import { isEmpty } from 'lodash';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '../models/api-response';
import { Observable } from 'rxjs';
import { GeneralStoreService } from '../store/general.store';

@Injectable({
    providedIn: 'root'
})
export class HelperService {

    constructor(
        private http: HttpClient,
        private generalStoreService: GeneralStoreService,
    ) { }

    hash(text: string): string {
        const sha = new jsSHA('SHA-512', 'TEXT', { encoding: 'UTF8' });
        sha.update(text);
        return sha.getHash('HEX');
    }

    checkPasswordMatch(passwordKey: string, passwordConfirmationKey: string): ValidatorFn {
        return (group: FormGroup): ValidationErrors => {
            if (isEmpty(group) || isEmpty(group.controls)) {
                return;
            }
            const password = group.controls[passwordKey];
            const passwordConfirmation = group.controls[passwordConfirmationKey];

            if (password.value !== passwordConfirmation.value) {
                passwordConfirmation.setErrors({ mismatchedPasswords: true });
            }
            return;
        };
    }

    resourcePrivateUrl(apiResourceKey: string): string {
        return `${environment.apiUrl}/${environment.apiVersion}/resource/private/${apiResourceKey}/download`;
    }

    resourcePublicUrl(apiResourceKey: string): string {
        return `${environment.apiUrl}/${environment.apiVersion}/resource/public/${apiResourceKey}`;
    }

    apiUrl(command: string): string {
        return `${environment.apiUrl}/${environment.apiVersion}/generic/command/${command}`;
    }

    apiDownloadUrl(): string {
        return `${environment.apiUrl}/${environment.apiVersion}/download/reports/data-set/md5/`;
    }

    apiReportPath(): string {
        return `${environment.apiUrl}/${environment.reportPath}`;
    }

    public dataURItoString(dataURI): string {
        return window.atob(dataURI);
    }

    public b64toBlob(b64Data, contentType = '', sliceSize = 512): Blob {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
  }

    public performStringReplacements(originalString: string, data: any, replacementToken: string): string {
        if (replacementToken === null || replacementToken === undefined || originalString.indexOf(replacementToken) === -1) return originalString;

        const keyValues = Object.keys(data).map((key) => ({ 'key': key, 'value': data[key] }))
        keyValues.forEach(keyValue => {
            originalString = originalString.replace(`${replacementToken}${keyValue.key}${replacementToken}`, keyValue.value);
        });
        return originalString;
    }

    executeCommand<T>(command: string, body: any): Observable<ApiResponse<T>> {
        return this.http.post<ApiResponse<T>>(`${environment.apiUrl}/${environment.apiVersion}/generic/command/${command}`, body);
    }

    async getMenu(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.executeCommand<any>(`api_user_application_menu_items`, { applicationCode: environment.appCode, menuKey: environment.mainMenuKey }).subscribe(result => {
                if (result.responseCode === 0  && result.data) {
                    this.generalStoreService.setMenu(result.data);
                    resolve(result.data);
                } else {
                    reject('No Menu Items');
                }
            });
        });
    }

    public async getUserLandingPageUrl(): Promise<string> {
        let menu = this.generalStoreService.getMenuValue();
        for (let menuItem of menu) {
            if (menuItem.routerLink?.length > 0) {
                return new Promise<any>(resolve => {
                    resolve(menuItem.routerLink);
                });
            }
        }
        return new Promise<any>(resolve => {
            resolve(null);
        });
    }
}
